import { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { activeVehicleWithPromise } from '../../../../../../actions/lookups';
import { toNumber } from '../utils/toNumber';
import _ from 'lodash';

const useMpiItems = (active_vehicle, formInstructions, tab, vehicle_id, setError) => {
  const dispatch = useDispatch();
  const work_item_presets = useSelector(state => state.settings_refresh?.work_item_presets || []);
  const installation = useSelector(state => state.settings_dealerships?.installation || {});
  const default_labor_rate = useSelector(state =>
    toNumber(
      _.find(
        state.settings_site?.dealer_settings || [],
        s => s.key === 'default_labor_rate' && s.dealership === installation.subdomain
      )?.value,
      100
    )
  );

  const filteredAndOrderedMpiItems = useMemo(() => {
    const result = {};
    const mpiItems = _.cloneDeep(active_vehicle?.mpi_work_items || []);

    if (!mpiItems.length || !formInstructions?.sections?.length) {
      return result;
    }

    formInstructions.sections.forEach(section => {
      const items = [];
      const presetIds = formInstructions.orderedPresetIds?.[section.id] || [];

      presetIds.forEach(presetId => {
        const item = _.find(mpiItems, i => i.work_item_preset_id === presetId);
        if (item && !items.includes(item)) {
          items.push(item);
        }
      });

      const sectionItems = mpiItems.filter(i =>
        i.work_item_preset_id === null &&
        i.form === formInstructions.currentFormName &&
        i.section === section.id &&
        i.show_mpi &&
        i.active &&
        !i.deleted &&
        !items.includes(i)
      );

      items.push(...sectionItems);

      try {
        items.sort((a, b) => {
          const aOrder = a?.order != null ? Number(a.order) : 0;
          const bOrder = b?.order != null ? Number(b.order) : 0;
          return aOrder - bOrder;
        });
      } catch (error) {
        // Silently handle sorting errors to prevent crashes
      }

      result[section.id] = items;
    });

    return result;
  }, [active_vehicle?.mpi_work_items, formInstructions]);

  const isDataReady = !!active_vehicle?.mpi_work_items?.length && !!formInstructions?.sections?.length && !!formInstructions?.currentFormName;

  const refreshVehicle = useCallback(() => {
    return dispatch(activeVehicleWithPromise(active_vehicle?.id || vehicle_id));
  }, [dispatch, active_vehicle?.id, vehicle_id]);

  return { groupedItems: filteredAndOrderedMpiItems, refreshVehicle, isDataReady };
};

export default useMpiItems;